<template lang="pug">
    v-content
        Header
        ResetPassword
        
</template>

<script>
import Header from "../components/SignupCard.vue";
import ResetPassword from "../components/ResetPassword.vue";
export default {
  components: {
    Header,
    ResetPassword
  }
};
</script>

<style>
.bg {
 /* background: url("../assets/bliss.jpg"); */
  background-size: cover;
}
</style>
